import { CSSProperties } from "react";
import Card from "../../common/components/Card";
import MotionContainer from "../../common/components/MotionContainer";

interface Props {
  title: string;
  company: string;
  companyLogo: string;
  date: string;
  imageStyles?: CSSProperties;
}

const ExperienceCard = (props: Props): JSX.Element => {
  return (
    <MotionContainer>
      <Card
        title={`${props.title} - ${props.company}`}
        image={props.companyLogo}
        body={<></>}
        date={props.date}
        imageStyles={props.imageStyles}
      />
    </MotionContainer>
  );
};

export default ExperienceCard;
